import { useEffect, useState } from 'react';
import { RotateCw } from 'lucide-react';
import { Button } from '@/ui/primitives';
import { useReleaseNotes } from './api';
import { enYeniSurum, YENI_SURUM_ARALIGI_MS, yeniSurumYayinda } from './yeni-surum';

/**
 * «Yeni sürüm yayınlandı» bandı — DST-00078.
 *
 * KENDİLİĞİNDEN YENİLEMİYOR, ve bu bilinçli. Sekmede yarım kalmış bir form
 * olabilir; habersiz bir yenileme o yazılanı siler ve bu, eski sürümle çalışmaya
 * devam etmekten daha pahalı bir kayıp. Band söylüyor, düğme veriyor, karar
 * okuyanda.
 *
 * Sekmenin yüklendiği sürüm `useReleaseNotes`'tan geliyor: o sorgu
 * `staleTime: Infinity` ile bir kez okunuyor, yani açılış anının sürümü olarak
 * kalıyor. Yayındaki sürüm ise burada ayrıca okunuyor — beş dakikada bir ve
 * sekmeye dönüldüğünde, çünkü günlerce arka planda açık duran bir sekme
 * dönüldüğü an haberi almalı, beş dakika sonra değil.
 */
export function YeniSurumBandi() {
  const notes = useReleaseNotes();
  const yuklenen = notes.data?.[0]?.version ?? null;
  const [yayinda, setYayinda] = useState<string | null>(null);
  const [ertelenen, setErtelenen] = useState<string | null>(null);

  useEffect(() => {
    if (!yuklenen) return;
    let iptal = false;
    const bak = async () => {
      try {
        const res = await fetch('/release-notes.json', { cache: 'no-cache' });
        if (!res.ok) return;
        const surum = enYeniSurum(await res.json());
        if (!iptal) setYayinda(surum);
      } catch {
        // Ağ yoksa bilinmiyor demektir, yeni sürüm var demek değil.
      }
    };
    const gorundu = () => {
      if (document.visibilityState === 'visible') void bak();
    };
    const zamanlayici = window.setInterval(() => void bak(), YENI_SURUM_ARALIGI_MS);
    document.addEventListener('visibilitychange', gorundu);
    return () => {
      iptal = true;
      window.clearInterval(zamanlayici);
      document.removeEventListener('visibilitychange', gorundu);
    };
  }, [yuklenen]);

  if (!yeniSurumYayinda(yuklenen, yayinda) || ertelenen === yayinda) return null;

  return (
    <div
      role="status"
      className="border-primary/30 bg-primary/10 text-fg px-safe-4 flex flex-wrap items-center gap-x-3 gap-y-2 border-b py-2 text-[13px] md:px-safe-6"
    >
      <span className="min-w-0 flex-1">
        <span className="font-semibold">Yeni bir sürüm yayınlandı.</span> Bu sekme eski sürümle
        çalışıyor; kaydetmediğiniz bir şey yoksa sayfayı yenileyin.
      </span>
      <span className="flex shrink-0 gap-2">
        <Button size="sm" variant="primary" onClick={() => window.location.reload()}>
          <RotateCw size={14} /> Yenile
        </Button>
        {/* «Sonra» yalnız BU sürüm için susturuyor: bir sonraki dağıtım yine
            söylenmeli, yoksa bir kez kapatan kişi bir daha hiç duymaz. */}
        <Button size="sm" variant="ghost" onClick={() => setErtelenen(yayinda)}>
          Sonra
        </Button>
      </span>
    </div>
  );
}
